import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { StartupService } from '@core/bootstrap/startup.service';

@Component({
  selector: 'app-default-page',
  template: '',
  styleUrls: [],
  standalone: false,
})
export class DefaultPageComponent implements OnInit {
  private startupService = inject(StartupService);
  private router = inject(Router);
  private msalAuthService = inject(MsalService);

  ngOnInit() {
    const isUserAuthenticated: boolean =
      this.msalAuthService.instance.getActiveAccount() != null || false;

    if (isUserAuthenticated && this.startupService.defaultRouteAuthenticated !== '') {
      this.router.navigate([this.startupService.defaultRouteAuthenticated || 'dashboard']);
    } else {
      this.router.navigate([this.startupService.defaultRoute || 'dashboard']);
    }
  }
}
